declare var d3: any;

import { Injectable } from '@angular/core';
import '../../assets/libs/d3.v3.min.js';


@Injectable()
export class CoordService {

  constructor() { }

  selectCaptador(captador){
    console.log("select captador not implemented");
  }

  buildVisualization(series, param){
    var parent = this;
    var selectedname = "";

    if(param.selectedCaptador)
      selectedname = param.selectedCaptador.Captador;

    var margin = {top: 30, right: 10, bottom: 10, left: 10},
          width = 620 - margin.left - margin.right,
          height = 340 - margin.top - margin.bottom;

    var x = d3.scale.ordinal().rangePoints([0, width], 1),
        y = {},
        dragging = {};

    var line = d3.svg.line(),
        axis = d3.svg.axis().orient("left"),
        background,
        foreground;

    d3.selectAll("#svg2 > *").remove();

    var svg = d3.select("#svg2")
          .attr("width", width + margin.left + margin.right)
          .attr("height", height + margin.top + margin.bottom)
          .attr("style", "background: #efefef;")
          .append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var titles = {Captador:"Captador",a0:"a0",a1:"a1",a2:"a2",
                    superficie:"superficie",unidades:"unidades",stotal:"superficie total"};

    var dimensions = d3.keys(titles).filter(function(d) {
      var dom = d3.extent(series, function(p) { return p[d]; });
      dom[0] = 0;
      dom[1] = dom[1] * 1.1;
      return d != "Captador" && (y[d] = d3.scale.linear()
            .domain(dom)
             .range([height, 0]));
    });

    x.domain(dimensions);

    // Add grey background lines for context.
    background = svg.append("g")
            .attr("class", "background")
            .selectAll("path")
            .data(series)
            .enter().append("path")
            .attr("d", path)
            .attr("stroke-dasharray", "5, 5");

    // Add blue foreground lines for focus.
    foreground = svg.append("g")
            .attr("class", "foreground")
            .selectAll("path")
            .data(series)
            .enter().append("path")
            .attr("d", path);

    d3.selectAll(".foreground").selectAll("path")
      .attr("style",function(d){
            if(d.Captador == selectedname)
              return "stroke:#eb2e2e; stroke-width:5px; z-index:100;";
              });

    d3.selectAll(".foreground").selectAll("path")
	    .on("mouseover", function(d){
		        d3.select(this).attr("style","stroke:#eb2e2e; stroke-width:5px; z-index:50;");
            /*main.append("text")
            .attr("x",xPos)
            .attr("y",yPos +height/2)
            .attr("class","tooltip")
            .text(d.name +": "+ delta.toFixed(0)); */
	     })
	    .on("mouseout",function(d){
	      if(d.Captador != selectedname)
		      d3.select(this).attr("style","stroke:#42b7d7; stroke-width:2px; z-index:25;");
	    })
	    .on("mousedown",function(d){
	      parent.selectCaptador(d);
	    });

    // Add a group element for each dimension.
    var g = svg.selectAll(".dimension")
            .data(dimensions)
            .enter().append("g")
            .attr("class", "dimension")
            .attr("transform", function(d) { return "translate(" + x(d) + ")"; });

    // Add an axis and title.
    g.append("g")
            .attr("class", "axiscoord")
            .each(function(d) { d3.select(this).call(axis.scale(y[d])); })
            .append("text")
            .style("text-anchor", "middle")
            .attr("y", -9)
            .text(function(d) { return d; });

    // Add and store a brush for each axis.
    g.append("g")
            .attr("class", "brush")
            .each(function(d) {
                  d3.select(this).call(y[d].brush = d3.svg.brush().y(y[d]).on("brushstart", brushstart).on("brush", brush));
              })
            .selectAll("rect")
            .attr("x", -8)
            .attr("width", 16);

    function position(d) {
      var v = dragging[d];
      return v == null ? x(d) : v;
    }

    function transition(g) {
      return g.transition().duration(500);
    }

    // Returns the path for a given data point.
    function path(d) {
      return line(dimensions.map(function(p) { return [position(p), y[p](d[p])]; }));
    }

    function brushstart() {
      d3.event.sourceEvent.stopPropagation();
    }

    // Handles a brush event, toggling the display of foreground lines.
    function brush() {
      var actives = dimensions.filter(function(p) { return !y[p].brush.empty(); }),
          extents = actives.map(function(p) { return y[p].brush.extent(); });
      foreground.style("display", function(d) {
        return actives.every(function(p, i) {
          return extents[i][0] <= d[p] && d[p] <= extents[i][1];
        }) ? null : "none";
      });
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/captadores/coord.service.ts